import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@dogdisk/shared'

// 类型对齐 server `internal/messaging/{conversation,ticket}.go`(2026-05-20 fix)。
// spec: docs/api-list/user/messages.md
//
// 注:server 端 ConversationRow / Ticket / MessageRow 是结构化数据,不含派生展示字段
// (如 peer_username / peer_avatar / last_message_text);UI 需自己 join 或退化展示。

export type TicketSummary = {
  ticket_number: string
  state: string
  type: string
}

export type Conversation = {
  conv_id: string
  /** 'private' | 'ticket' | 'system' */
  type: string
  pinned: boolean
  /** 服务端 derive(私信:对方昵称;工单:工单标题);可空 */
  title: string
  /** 服务端 derive 摘要;可空 */
  subtitle: string
  avatar_url: string | null
  last_message_at: string | null
  unread_count: number
  /** 仅 type='ticket' 时附加 */
  ticket?: TicketSummary
}

export type Message = {
  id: string
  conversation_id: string
  sender_id: string
  content: string
  attachments: string[] | null
  created_at: string
}

export type Ticket = {
  id: string
  conversation_id: string
  ticket_number: string
  applicant_id: string
  assignee_id: string | null
  type: string
  title: string
  priority: string
  /** server 用 `state` 不是 `status`;DB 列 ticket.state */
  state: 'open' | 'pending' | 'in_progress' | 'resolved' | 'closed' | string
  resolved_at: string | null
  closed_at: string | null
  created_at: string
  updated_at: string
}

export function useConversations() {
  return useQuery({
    queryKey: ['msg', 'conversations'] as const,
    // gapi-restful-regroup:GET /gapi/user/conversations
    queryFn: () => apiClient.get<{ conversations: Conversation[] }>('/gapi/user/conversations'),
    staleTime: 10_000,
  })
}

export function useConversationMessages(conversationId: string | undefined) {
  return useQuery({
    queryKey: ['msg', 'messages', conversationId] as const,
    enabled: Boolean(conversationId),
    // gapi-restful-regroup:GET /gapi/user/conversations/{conversation_id}/messages
    queryFn: () =>
      apiClient.get<{ messages: Message[] }>(
        `/gapi/user/conversations/${conversationId!}/messages`,
      ),
  })
}

export function useMyTickets() {
  return useQuery({
    queryKey: ['msg', 'tickets', 'mine'] as const,
    // gapi-restful-regroup:GET /gapi/user/tickets?scope=mine
    queryFn: () => apiClient.get<{ tickets: Ticket[] }>('/gapi/user/tickets', {
      query: { scope: 'mine' },
    }),
    staleTime: 10_000,
  })
}
